import { createHttpClient, opsApi } from "@nahal/api-client";

const baseUrl = import.meta.env.VITE_PLATFORM_API_URL ?? "http://localhost:8083";

export const http = createHttpClient({ baseUrl, credentials: "include" });

export const api = opsApi(http);
